export default "__VITE_ASSET__CMwZrd88__"